import { FormHelperText } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

export const MAX_AWARD_LETTER_TEXT_LENGTH = 4000;

const awardLetterTextLength = (text: string | null | undefined) => (text ?? "").trim().length;

export const exceedsAwardLetterTextLimit = (text: string | null | undefined) =>
  awardLetterTextLength(text) > MAX_AWARD_LETTER_TEXT_LENGTH;

export const AwardLetterTextCounter = ({ text }: { text: string | null | undefined }) => {
  const { t } = useTranslation();
  return (
    <FormHelperText mt="1">
      {t("{{count}} / {{max}} characters", {
        count: awardLetterTextLength(text),
        max: MAX_AWARD_LETTER_TEXT_LENGTH,
      })}
    </FormHelperText>
  );
};

export const AwardLetterTextLimitMessage = () => {
  const { t } = useTranslation();
  return <>{t("The text can be at most {{max}} characters.", { max: MAX_AWARD_LETTER_TEXT_LENGTH })}</>;
};
